"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "sectionRefs"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".NavigationRibbon {\n  display: flex;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  background-color: #d8d8d8;\n  padding: 0.5rem 1rem;\n  position: sticky;\n  top: 0;\n}\n@media (max-width: 48rem) {\n  .NavigationRibbon {\n    flex-direction: column;\n  }\n}\n.NavigationRibbon ul {\n  margin-bottom: 0;\n}\n.NavigationRibbon__navigation__item {\n  border-radius: 3px;\n  margin: 0 0.5rem 0 0;\n  padding: 1rem;\n  display: inline-block;\n  text-align: center;\n  list-style: none;\n  transition: ease-in-out 150ms;\n  cursor: pointer;\n}\n@media (max-width: 48rem) {\n  .NavigationRibbon__navigation__item {\n    margin: 0 0 0.5rem;\n  }\n}\n.NavigationRibbon__navigation__item.active {\n  border-radius: 3px;\n  background-color: #0a5ec0;\n  color: #ffffff !important;\n}\n.NavigationRibbon__navigation__item:hover {\n  border-radius: 3px;\n  background-color: #0a5ec0;\n  color: #ffffff !important;\n}";
  var fileName = "NavigationRibbon_NavigationRibbon";
  var element = document.querySelector("style[data-sass-component='NavigationRibbon_NavigationRibbon']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var NavigationRibbon = function NavigationRibbon(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$sectionRefs = _ref.sectionRefs,
    sectionRefs = _ref$sectionRefs === void 0 ? [] : _ref$sectionRefs,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var headerRef = (0, _react.useRef)();
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visibleSection = _useState2[0],
    setVisibleSection = _useState2[1];
  var getDimensions = function getDimensions(ele) {
    var _ele$getBoundingClien = ele.getBoundingClientRect(),
      height = _ele$getBoundingClien.height;
    var offsetTop = ele.offsetTop;
    var offsetBottom = offsetTop + height;
    return {
      height: height,
      offsetTop: offsetTop,
      offsetBottom: offsetBottom
    };
  };
  (0, _react.useEffect)(function () {
    var handleScroll = function handleScroll() {
      var _getDimensions = getDimensions(headerRef.current),
        headerHeight = _getDimensions.height;
      var scrollPosition = window.scrollY + headerHeight;
      var selected = sectionRefs.find(function (_ref2) {
        var ref = _ref2.ref;
        var ele = ref.current;
        if (ele) {
          var _getDimensions2 = getDimensions(ele),
            offsetBottom = _getDimensions2.offsetBottom,
            offsetTop = _getDimensions2.offsetTop;
          return scrollPosition > offsetTop - headerHeight && scrollPosition < offsetBottom;
        }
      });
      if (selected && selected.section !== visibleSection) {
        setVisibleSection(selected.section);
      } else if (!selected && visibleSection) {
        setVisibleSection(undefined);
      }
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [visibleSection]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    className: "NavigationRibbon ".concat(className),
    ref: headerRef
  }, rest), {}, {
    children: sectionRefs.map(function (section, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
          className: "NavigationRibbon__navigation__item  ".concat(visibleSection === "".concat(section.section) ? 'active' : ''),
          onClick: function onClick() {
            window.scrollTo({
              top: section.ref.current.offsetTop - headerRef.current.clientHeight,
              behavior: 'smooth'
            });
            setVisibleSection(section.ref.current);
          },
          children: section.section
        })
      }, index);
    })
  }));
};
var _default = NavigationRibbon;
exports["default"] = _default;